import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "veripool_token";

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setAuthToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const clearAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

const formatDetail = (detail, fallback) => {
  // FastAPI renvoie soit une string, soit une liste d'erreurs de validation (422).
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (d && typeof d === "object" ? d.msg : String(d)))
      .filter(Boolean);
    return msgs.length ? msgs.join(" · ") : fallback;
  }
  return detail || fallback;
};

export const getApiError = (error, fallback = "Une erreur est survenue") =>
  String(formatDetail(error?.response?.data?.detail, fallback))
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .replace(/sms\s*pool|smspool|juicy\s*sms|juicysms|moneroo|fedapay|1001\s*sms|1001sms/gi, "service")
    .replace(/pool/gi, "opérateur")
    .replace(/provider/gi, "service")
    .replace(/fournisseur/gi, "service");
